/**
 * @param {{ leg_management_version?: number } | null | undefined} entity
 * @returns {boolean}
 */
export const isLegManagementEnabled = (entity) =>
  entity?.leg_management_version === 2;

const EQUIPMENT_EXEMPT_LEG_TYPES = ['chassis_split', 'bobtail'];

/**
 * @param {{ leg_management_version?: number, leg_type?: string } | null | undefined} shipment
 * @returns {boolean}
 */
export const isEquipmentExemptLegType = (shipment) =>
  isLegManagementEnabled(shipment) &&
  EQUIPMENT_EXEMPT_LEG_TYPES.includes(shipment?.leg_type);
